import React from 'react';
import styled from 'styled-components';
import shadowPlusLogo from '../atoms/data/standard-color.svg';

const HeaderHome = (props) => {
    return(
        <Body>
            <Title>
                <img alt="shdplus-logo" src={shadowPlusLogo} style={{width: "150px"}} />
            </Title>            
        </Body>
    );
}

export { HeaderHome };

const Body = styled.div`
    width: 100%;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 32px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
    position: relative;
    z-index: 2;
`;
const Title = styled.div`
    position: relative;
    width: 100%;
    margin:auto;
    font-size: 24px;
    text-align: center;
`;